import PhotoSwipe from '@PhotoSwipe'
import $ from 'jquery'
import { externalUrl } from '../../../shared/externalUrl'
import { setupModal } from '../../_modal'
import { transformRawEvent } from './transformRawEvent'

export default {
  name: 'EventInstanceModal',

  data() {
    return {
      title: null,
      url: null,

      event: null,
      loading: true,
    }
  },

  methods: {
    show(title, url) {
      this.title = title
      this.url = url
      this.loadData()
      this.modal.open()
    },

    loadData() {
      if (this.dataXhr) {
        this.dataXhr.abort()
      }

      this.event = null
      this.loading = true

      this.dataXhr = $.ajax({
        type: 'GET',
        url: this.url,
        dataType: 'json',
        success: (event) => {
          this.event = transformRawEvent(event)
        },
      }).always(() => {
        this.loading = false
      })
    },

    enlargePhoto() {
      const gallery = new PhotoSwipe({
        index: 0,
        bgOpacity: 1,
        dataSource: [
          {
            src: window.APP.context.site.files_url + this.event.photo.path,
            w: this.event.photo.width,
            h: this.event.photo.height,
          },
        ],
      })
      gallery.init()
    },

    emailUrl(url) {
      return `mailto:${url}`
    },

    externalUrl(url) {
      return externalUrl(url)
    },
  },

  created() {
    this.dataXhr = null
    this.modal = null
  },

  mounted() {
    this.$nextTick(() => {
      this.modal = setupModal(this.$el, { vOffset: 0 })
    })
  },

  // language=HTML
  template: `
    <div class="event-modal reveal large" data-animation-in="scale-in-up" data-animation-out="scale-out-down">
      <button class="close-button" data-close aria-label="Close modal" type="button">
        <span aria-hidden="true"><span class="material-icons" aria-label="">close</span></span>
      </button>

      <div class="event">
        <div v-if="event && event.organization" class="event__organization">
          {{ event.organization }}
        </div>

        <div class="event__title-and-categories">
          <div class="event__title">{{ title }}</div>
          <div v-if="event && event.categories.length" class="event__categories">
            <div
              v-for="category in event.categories"
              :key="category.name"
              class="event__category"
            >
              {{ category.name }}
            </div>
          </div>
          <div v-if="event && event.locationClassification.length > 0">
            <span 
              class="label secondary"
              style="margin-right: 5px;"
              v-for="classification in event.locationClassification"
            >
              {{ classification }}
            </span>
          </div>
        </div>

        <div class="event__loading" v-if="loading">
          <ui-progress-circular :size="36" :indeterminate="true" />
        </div>

        <div class="event__details" v-if="event">
          <div v-if="event.cancelled" class="alert callout">This event has been cancelled!</div>
          
          <div class="event__date">
            {{ event.dateStartMoment.format('MMMM Do') }}
            <span v-if="event.dateEndMoment && event.dateStart !== event.dateEnd">
                – {{ event.dateEndMoment.format('MMMM Do') }}
              </span>
            <template v-if="event.timeStartMoment">
              at {{ event.timeStartMoment.format('h:mma') }}
              <template v-if="event.timeEndMoment && event.timeStart !== event.timeEnd">
                – {{ event.timeEndMoment.format('h:mma') }}
              </template>
            </template>
          </div>

          <div v-if="event.photo" class="photo">
            <img :src="event.photo.url" alt="" @click="enlargePhoto">
          </div>
          
          <table class="transparent">
            <tbody>
              <tr v-if="event.county">
                <th scope="row">County:</th>
                <td>{{ event.county }}</td>
              </tr>
              <tr v-if="event.admission">
                <th scope="row">Admission:</th>
                <td>{{ event.admission }}</td>
              </tr>
              <tr v-if="event.location">
                <th scope="row">Location:</th>
                <td>{{ event.location }}</td>
              </tr>
              <tr v-if="event.address">
                <th scope="row">Address:</th>
                <td>
                  <nl2br tag="span" :text="event.address" />
                </td>
              </tr>
              <tr v-if="event.contactName || event.contactPhone || event.contactEmail">
                <th scope="row">Contact:</th>
                <td>
                  <div v-if="event.contactName">{{ event.contactName }}</div>
                  <div v-if="event.contactPhone">{{ event.contactPhone }}</div>
                  <div v-if="event.contactEmail">
                    <a :href="emailUrl(event.contactEmail)" target="_blank">Click here to email</a>
                    <span class="material-icons" aria-hidden="true" style="vertical-align: top">open_in_new</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div
            v-if="!event.richDescription && event.textDescription"
            class="description"
            v-html="event.textDescription"
          />

          <div v-if="event.richDescription" class="description" v-html="event.richDescription"></div>

          <div class="event__link" v-if="event.url">
            <a class="button" :href="externalUrl(event.url)" target="_blank">
              <span>More Information</span>
              <span class="material-icons" aria-hidden="true" style="vertical-align: top">open_in_new</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    </div>
  `,
}
